// extracted by mini-css-extract-plugin
export default {"btn":"BackBtn_btn__O1OIR","arrow":"BackBtn_arrow__82KOX","text":"BackBtn_text__rZcua"};